<template>
  <v-container>
    <Hero :data="pageData" />
    <v-row>
      <v-col align="center"
             justify="center">
        <h2>Navigate Social Insights Engine</h2>
      </v-col>
    </v-row>
    <v-row class="d-flex" v-for="(feature, index) in pageData.features" :key="index">
      <v-col cols="12" md="6" :order="index%2 === 0 ? 'last' : 'first'">
        <div class="caption text-uppercase">{{ feature.headline[0].text }}</div>
        <h1 class="heading mb-8">{{ feature.title[0].text }}</h1>
        <prismic-rich-text :field="feature.copy"/>
        </v-col>
      <v-col cols="12" md="6">
        <v-img
          height="400px"
          contain
          :src="feature.image.url"></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Hero from '@/components/hero';

export default {
  name: 'Insights',
  components: { Hero },
  data: () => ({
    pageData: [],
  }),
  methods: {
    getContent() {
      this.$prismic.client.getSingle('insights', { lang: this.$i18n.locale })
        .then((document) => {
          this.pageData = document.data;
          this.loading = false;
        });
    },
  },
  created() {
    this.getContent();
  },
};
</script>

<style scoped>
  .hero-cta {
    z-index: 1;
  }
  .hero-text {
    font-family: Maxwell, Arial, serif;
    font-size: 3.5em;
    line-height: 60px;
    color: black;
  }
</style>
